import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appShiftClick]',
  standalone: true,
})
export class CtrlShiftDirective {
  @Output() appShiftClick = new EventEmitter<MouseEvent>();

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.shiftKey) {
      event.preventDefault();
      this.appShiftClick.emit(event);
    }
  }
}
